// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__19BX7","head":"Table_head__2OfsH","col":"Table_col__1pxY7"};